import { render } from "./TopDesktopMenuBar.vue?vue&type=template&id=af58b2ec&scoped=true"
import script from "./TopDesktopMenuBar.vue?vue&type=script&lang=js"
export * from "./TopDesktopMenuBar.vue?vue&type=script&lang=js"

import "./TopDesktopMenuBar.vue?vue&type=style&index=0&id=af58b2ec&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af58b2ec"]])

export default __exports__